module.exports = __webpack_public_path__ + "img/data-quality-music-publishers-level 2.6f3ee125.svg";